<template>
  <div :class="['kee-list', {'kee-list-drawer': getIfClientDrawerTag}]">
    <VHeader></VHeader>
    <div class="content-wrap">
      <div class="__opts">
        <div>
          <NewKeeBreadcrumb></NewKeeBreadcrumb>
        </div>
        <div class="search-content">
          <el-input v-model="searchInput" :placeholder="$t('please_input')">
            <el-button slot="append" icon="el-icon-search" type="primary" size="small" @click="getTable">
              {{ $t('btn_search2') }}
            </el-button>
          </el-input>
          <el-button v-if="!isKpmgUser" icon="el-icon-star-off" size="small" class="wl-green-small favourite"
            @click="goToMyCourse">
            {{ $t('kee_my') }}
          </el-button>
        </div>
      </div>

      <div class="content-list-box">
        <el-tabs v-model="activeName" @tab-click="onSizeChange(8)" class="kee-tabs">
          <template v-for="(item, index) in menu">
            <el-tab-pane :label="$t(item.name)" :name="item.tag"></el-tab-pane>
          </template>
        </el-tabs>
        <div class="course-list" v-if="courseList.length">
          <div class="course-item-outer" v-for="item in courseList" :key="item.courseId">
            <div class="course-item" @click="goDetail(item)">
              <div :class="['isNew', $i18n.locale === 'en' ? '__en' : '']" v-if="item.newCourseFlag"></div>
              <img :src="item.coverImgUrl" alt="" class="course-pic" />
              <div class="title-row">
                <el-tooltip :content="item.title" :disabled="item.title.length <= 24">
                  <div class="course-title">
                    {{ item.title }}
                  </div>
                </el-tooltip>
              </div>
              <div class="course-item-child">
                <div class="course-price">
                  <el-tag :type="item.form === 'ONLINE' ? 'success' : 'danger'" size="mini"
                    :style="[item.form === 'ONLINE' ? {'background': '#1E49E20F','color': '#1E49E2'} : {'margin-left': '0'}]">
                  {{ item.form === 'ONLINE' ? $t('courseInfo_online') : $t('courseInfo_offline') }}
                  </el-tag>
                  <el-tag :type="item.chargeType === 'FREE' ? 'success' : 'danger'" size="mini"
                    :style="[item.chargeType === 'FREE' ? {'margin-left': '10px','background': '#1E49E20F','color': '#1E49E2'} : {'margin-left': '10px'}]">
                    {{ item.chargeType === 'FREE' ? $t('kee_free') : $t('kee_charge') }}
                  </el-tag>
                </div>
                <div :class="['course-collect', getUser.userType == '2' ? '' : 'course-collect-kp']"
                  @click.stop="collectClick(item)">
                  <img src="@/assets/img/icon-collect.svg" v-if="item.collectFlag" class="collect-icon" width="100%" />
                  <img src="@/assets/img/icon-uncollect.svg" v-else class="collect-icon" width="100%" />
                  <span>{{ $t('kee_like') }}</span>
                </div>
              </div>
              
              <div class="course-item-child">
                <div class="course-time">
                  <span v-show="item.form === 'ONLINE'">
                    {{ $t('kee_duration') }}: {{ durationTrans(item.sumDurationFormat) }}
                  </span>
                </div>
                
              </div>
            </div>
          </div>
        </div>
        <el-empty class="course-list" v-else :description="$t('TABLE_NO_DATA')"></el-empty>
        <el-pagination class="wl-pagination" :current-page="pagination.pageNum" :page-size="pagination.pageSize"
          @size-change="onSizeChange" @current-change="onCurrentPageChange" :page-sizes="[8, 16, 24, 48, 96]"
          layout="prev, pager, next, sizes, total" :total="pagination.total">
        </el-pagination>
      </div>

      <div v-if="activeName === 'TAX_COURSES'" :class="['qrcode', isOpen ? 'is-open' : 'not-open']">
        <div v-show="!isOpen" @click="isOpen = !isOpen" class="not-open-inner" :title="$t('kpmgFinanceOnline')">
          <img src="@/assets/img/kee/icon.png" width="25" alt="">
          <div>{{ $t('kpmgFinanceOnline') }}</div>
        </div>
        <div v-show="isOpen" class="is-open-inner">
          <div @click="isOpen = !isOpen" class="close">
            {{ $t('fold') }} X
          </div>
          <div class="tit">
            <img src="@/assets/img/kee/icon.png" width="25" alt="">
            <span>{{ $t('kpmgFinanceOnline') }}</span>
          </div>
          <img src="@/assets/img/kee/qrcode.png" style="width: 100%;" alt="">
          <p>{{ $t('qrcodeTips') }}</p>
        </div>
      </div>
    </div>
    <vBottom></vBottom>
  </div>
</template>

<script>
import VHeader from '@/components/common/Header.vue'
import VBottom from '@/components/common/Bottom'
import NewKeeBreadcrumb from './NewKeeBreadcrumb.vue'
import { mapGetters } from 'vuex'
import API from '@/api'

export default {
  components: {
    VHeader,
    VBottom,
    NewKeeBreadcrumb,
  },
  data() {
    return {
      isOpen: true,
      searchInput: '',
      activeName: 'ACCOUNTING_COURSE',
      offlineDataLength: 0,
      courseList: [],
      pagination: {
        pageNum: 1,
        pageSize: 8,
        total: 0
      },
      loading: false,
      menu: [
        { desc: '会计课程', name: "kee_menu_1", src: require("@/assets/img/Insights-icon – 1.png"), tag: "ACCOUNTING_COURSE", newTag: "accountingCourseNewFlag" },
        { desc: '税务课程', name: "kee_menu_2", src: require("@/assets/img/Insights-icon – 2.png"), tag: "TAX_COURSES", newTag: "taxCoursesNewFlag" },
        { desc: '发展课程', name: "kee_menu_3", src: require("@/assets/img/Insights-icon – 3.png"), tag: "DEVELOPMENT_COURSES", newTag: "developmentCoursesNewFlag" },
        { desc: '审计协作', name: "kee_menu_4", src: require("@/assets/img/Insights-icon – 4.png"), tag: "AUDIT_COOPERATION", newTag: "auditCooperationNewFlag" },
        // {name: "kee_menu_5", src: require("@/assets/img/Insights-icon – 5.png")},
      ],
    }
  },
  computed: {
    ...mapGetters('common', {
      getUser: 'getUser',
      getIfClientDrawerTag: 'getIfClientDrawerTag',
    }),
    isKpmgUser() {
      return this.getUser.userType === '1'
    },
  },
  watch: {
    activeName: {
      handler(v) {
        localStorage.setItem('kee_list_kccTag', v)
      },
    },
  },
  mounted() {
    // this.getTable()
    // 初始化时查询线下活动，无数据时隐藏相应tab页签
    this.activeName = this.$route.query.kccTag || localStorage.getItem('kee_list_kccTag') || 'ACCOUNTING_COURSE'
    this.getTable()
  },
  methods: {
    durationTrans(v) {
      return [v[0], this.$t('hour'), v[1], this.$t('minute'), v[2], this.$t('second')].join(' ')
    },
    onCurrentPageChange(current) {
      this.pagination.pageNum = current
      this.getTable()
    },
    onSizeChange(current) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = current
      this.getTable()
    },
    getTable(activeName) {
      // if (this.activeName == 'OFFLINE') {
      //   this.courseList = []
      //   this.pagination.total = 0
      //   return
      // }
      this.loading = true
      let param = {
        kccTag: this.activeName,
        fuzzy: this.searchInput,
        // form: 'OFFLINE', // ONLINE / OFFLINE
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
      }
      API.insights.queryCourseInfo(param).then((res) => {
        if (res.code === '1') {
          if (activeName === 'OFFLINE') {
            // 初始化时查询线下活动，无数据时隐藏相应tab页签
            this.offlineDataLength = res.data.size
          } else {
            this.courseList = res.data.records || []
            this.pagination.total = res.data.total
          }
        } else {
          this.$message.error(this.$t(res.code))
        }
        this.loading = false
      })
    },
    goDetail(item) {
      this.$router.push({ name: 'courseDetailNew', query: { courseId: item.courseId } })
    },
    goToMyCourse() {
      this.$router.push({ name: 'myCourseNew' })
    },
    collectClick(item) {
      let param = {
        courseId: item.courseId,
        flag: item.collectFlag ? 0 : 1
      }
      API.insights.updateCollectFlagRecord(param).then((res) => {
        if (res.code === '1') {
          if (item.collectFlag) {
            item.collectFlag = 0
          } else {
            item.collectFlag = 1
          }
        } else {
          this.$message.error(this.$t(res.code))
        }
        this.loading = false
      })
    }
  }
}
</script>

<style>
.kee-list .content-wrap {
  margin: 0 200px;
}

.kee-list .content-wrap .__opts {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.kee-list .content-wrap .search-content {
  display: flex;
  margin-top: 30px;
}

.kee-list-drawer {
  height: 100%;
}

.kee-list-drawer .content-wrap {
  margin: 0;
}

.kee-list-drawer .content-wrap .wl-pagination {
  background: transparent;
}

.search-content .favourite {
  margin-left: 10px;
}

.content-list-box .el-tabs {
  height: 52px;
}

.kee-tabs .el-tabs__header {
  padding: 0 !important;
}

.kee-tabs .el-tabs__content {
  height: 0 !important;
}


.course-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100% - 110px);
  overflow-y: auto;
}

.course-list::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 8px !important;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 8px !important;
}

.course-list.el-empty {
  flex-direction: column;
}

.course-list .course-item-outer {
  width: calc(25% - 20px);
  /* height: 500PX; */
  margin: 10px;
}

.course-list .course-item-outer .course-item {
  height: 100%;
  padding: 15px;
  border-radius: 5px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s linear;
  box-shadow: 0 0 10px #e6e6e6;
}

.course-list .course-item-outer .course-item .course-pic {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 5px;

}

.course-list .course-item-outer .course-item:hover {
  box-shadow: 1px 1px 8px 8px #efeff5;
}

.course-list .course-item-outer .course-item .isNew {
    display: inline-block;
    position: absolute;
    background: url("~@/assets/img/kpicon-new-6.png") center center/100% 100% no-repeat;
    width: 60PX;
    height: 30PX;
    right: -15PX;
    top: -10PX;
}

.course-list .course-item-outer .course-item .isNew.__en {
  width: 45PX;
  height: 25PX;
  background: url("~@/assets/img/kpicon-new-3.png") center center/100% 100% no-repeat;
}


.course-list .course-item-outer .course-item .title-row {
  width: 100%;
  font-size: 16px;
  font-weight: 600;
  margin-top: 5px;
  /* display: flex;
    flex-direction: row;
    justify-content: center; */
  /* height: 100px; */
}

.course-list .course-item-outer .course-item .title-row .course-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.course-list .course-item-outer .course-item .course-price {
  font-size: 12PX;
}

.course-list .course-item-outer .course-item .course-price .el-tag {
  font-size: 12PX;
}

.course-list .course-item-outer .course-item .course-item-child {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  align-items: center;
}

.course-list .course-item-outer .course-item .course-item-child .course-time {
  font-size: 12PX;
}

.course-list .course-item-outer .course-item .course-item-child .course-collect {
  display: flex;
  align-items: center;
  font-size: 12PX;
}

.course-list .course-item-outer .course-item .course-item-child .course-collect img {
  width: 12PX;
  position: relative;
  top: -1px;
  margin-right: 4px;
}

.course-list-item {
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  margin: auto;
  margin-bottom: 20px;
  height: 600px;
}

.course-list-item:hover {
  background-color: rgba(0, 0, 0, 0.1);
  transition: all 1s;
}

.qrcode {
  position: absolute;
  right: 0;
  top: 120px;
  box-shadow: 0 0 1px #ebebeb;
  transition: all .2s;
  z-index: 1;
}

.qrcode.not-open {
  width: 35px;
  border-radius: 20px;
  cursor: pointer;
  background-image: url('~@/assets/img/kee/bg-not-open.png');
  background-position: 0;
}

.qrcode .not-open-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 0;
}

.qrcode .not-open-inner div {
  writing-mode: vertical-lr;
  font-size: 13px;
  letter-spacing: 3px;
  color: #fff;
  margin-top: 10px;
}

/* .en-lang .qrcode .not-open-inner div {
  display: none;
} */

.qrcode.is-open {
  padding: 0 15px;
  border-radius: 8px;
  cursor: default;
  background-image: url('~@/assets/img/kee/bg-open.png');
  background-size: 100%;
}

.qrcode .is-open-inner {
  padding: 15px 0 10px 0;
  text-align: center;
}

.qrcode .is-open-inner .close {
  position: absolute;
  top: 0px;
  right: 2px;
  font-size: 12px;
  transform: scale(0.9);
  color: rgb(29, 44, 200);
  cursor: pointer;
}

.en-lang .qrcode .is-open-inner .close {
  top: 4px;
  right: 8px;
  transform: scale(1);
}

.qrcode .is-open-inner .tit {
  display: flex;
  align-items: center;
  font-size: 13px;
  margin: 10px 0;
}

.qrcode .is-open-inner .tit span {
  margin-left: 5px;
  color: #fff;
}

.qrcode .is-open-inner img {
  border-radius: 5px;
  max-width: 150px;
}

.qrcode .is-open-inner p {
  text-align: center;
  color: #fff;
  margin-top: 5px;
}
</style>